import { AxiosPromise } from 'axios';
import { useSingletonLoading } from 'common/hooks';
import { useEffect, useState } from 'react';

type Props<T> = {
  id: number;
  getValue: (param?: string) => T;
  key?: any[];
  getValorParametro: (id: number) => AxiosPromise<string | null>;
};

export const useParametro = <T>({
  id,
  getValue,
  key = [],
  getValorParametro
}: Props<T>) => {
  const [parametro, setParametro] = useState<string | undefined>(undefined);
  const [isLoading, setLoading] = useSingletonLoading();
  const [started, setStarted] = useState(false);
  const keyDeps = JSON.stringify(key);

  useEffect(() => {
    setStarted(true);
    setLoading(
      () =>
        getValorParametro(id).then(value => {
          setParametro(value?.data || undefined);
        }),
      keyDeps
    );
    return () => {
      setStarted(false);
    };
  }, [keyDeps, id]);

  return [getValue(parametro), !started || isLoading] as const;
};

export const getBooleanValue = (value?: string) => value === 'S';

export const getNumberValue = (value?: string) => Number(value);
